/*
 * Copyright © 2025 Apple Inc. Adapted for Bowstring from SF Symbols Version 6.0.
 */

import { type Symbol } from "@bowstring/interfaces";


// noinspection JSUnusedGlobalSymbols
export const _PinFill: Symbol = {
  paths:         [
    {
      definition: "M0 22.5586C0 23.7188 0.808594 24.4922 2.0625 24.4922L10.2773 24.4922L10.2773 32.1445C10.2773 34.1836 11.1211 35.918 11.4492 35.918C11.7891 35.918 12.6211 34.1836 12.6211 32.1445L12.6211 24.4922L20.8477 24.4922C22.1016 24.4922 22.8984 23.7188 22.8984 22.5586C22.8984 19.3359 20.3555 16.043 16.1836 14.5547L15.6914 7.54688C17.7188 6.375 19.5234 4.96875 20.3203 3.92578C20.6836 3.43359 20.8594 2.96484 20.8594 2.54297C20.8594 1.6875 20.2148 1.05469 19.2188 1.05469L3.69141 1.05469C2.69531 1.05469 2.03906 1.6875 2.03906 2.54297C2.03906 2.96484 2.21484 3.43359 2.58984 3.92578C3.375 4.96875 5.19141 6.38672 7.20703 7.54688L6.71484 14.5547C2.55469 16.043 0 19.3359 0 22.5586Z",
      opacity:    0.85,
    },
  ],
  viewBoxHeight: 35.918,
  viewBoxWidth:  23.25,
};
